export default __webpack_public_path__ + "static/icon-3-4-f260c60967f0d3d1b1949f31c10fdbd2.png";